import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { InterventionContentItem } from '../../../models/intervention-content-item';
import { ApiService } from 'src/app/core/services/api/api.service';
import { InterventionContentItemOrder } from '../../../models/intervention-content-item-order';

@Injectable({
  providedIn: 'root',
})
export class InterventionContentItemService {
  addContentItemToIntervention(
    studyId: number,
    interventionId: number,
    itemId: number,
    itemType: string
  ): Observable<InterventionContentItem> {
    return this.apiService.post<InterventionContentItem>(
      `/dashboard/study/${studyId}/intervention/${interventionId}/${itemType}/${itemId}`,
      {}
    );
  }

  removeContentItemFromIntervention(
    studyId: number,
    interventionId: number,
    itemId: number,
    itemType: string
  ): Observable<void> {
    return this.apiService.delete<void>(
      `/dashboard/study/${studyId}/intervention/${interventionId}/${itemType}/${itemId}`
    );
  }

  saveContentItemsSortingOrder(
    studyId: number,
    interventionId: number,
    sortingOrder: InterventionContentItemOrder[]
  ): Observable<InterventionContentItemOrder[]> {
    return this.apiService.put<InterventionContentItemOrder[]>(
      `/dashboard/study/${studyId}/intervention/${interventionId}/contentsort`,
      sortingOrder
    );
  }

  constructor(private apiService: ApiService) {}
}
